(function () {
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('lushe:wishlist') || '[]');
    } catch (e) {
      return [];
    }
  }

  function refresh() {
    var page = document.querySelector('[data-lushe-wishlist-page]');
    if (!page) return;

    var ids = getWishlist().map(String);
    var items = page.querySelectorAll('[data-lushe-wishlist-item]');
    var visibleCount = 0;

    items.forEach(function (item) {
      var match = ids.indexOf(item.getAttribute('data-product-id')) !== -1;
      item.hidden = !match;
      if (match) visibleCount += 1;
    });

    var empty = page.querySelector('[data-lushe-wishlist-empty]');
    var grid = page.querySelector('[data-lushe-wishlist-grid]');
    if (empty) empty.hidden = visibleCount > 0;
    if (grid) grid.hidden = visibleCount === 0;
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-wishlist-toggle]')) {
      window.setTimeout(refresh, 0);
    }
  });
})();
